module.exports = __webpack_public_path__ + "static/media/grillme_home_add_quiz.27a6a82d.png";